// localStore.get('requestingLogin')
import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faSignIn} from '@fortawesome/pro-solid-svg-icons';
import {canLoginPublicAccess} from '../enablers';
import {UserActionLabel} from '../locales';
import {USER_EVENT} from './constants';

export const userActionLoginPublicAccessIcon = faSignIn;

/**
 * Login as user
 * @param params
 * @returns Action
 */
export const userActionLoginPublicAccess = (
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'user-login-public-access',
	cb: () => dispatcher.trigger(USER_EVENT.LOGIN_PUBLIC_ACCESS),
	enableTest: () => canLoginPublicAccess(),
	icon: userActionLoginPublicAccessIcon,
	get label() {
		return UserActionLabel.LOGIN;
	},
	...params,
});

export default userActionLoginPublicAccess;
